import { ProductType } from "../enums/product-type.enum";
import { ProductVersionStatus } from "../enums/product-version-status.enum";

export interface ProductVersion {
    id: string;

    // other entity ids
    productId: string;
    fixtureId: string;
    robotProgramId: string;
    plasticsProductCostModelId?: string;
    status: ProductVersionStatus;
    versionNumber: number | null;

    partNumber: string;
    type: ProductType;
    imageUrl: string;
    thumbnailImageUrl: string;
    stlUrl: string;
    description: string;
    customerPartNumber: string;
    customerId: string;
    drawingResourceId: string;

    createdById: string;
    createdOn: Date;
    updatedById: string;
    updatedOn: Date;
    releasedById: string | null;
    releasedOn: Date | null;
    releaseComment: string;

    //only for finished products
    defaultFinishingStationId: string;
    finishingProcedureId: string;

    //only for moldedProducts
    requiresAsMoldedLabel: boolean;
    moldFamilyId: string,

    // items that are kept in inventory so they can be 
    // applied to an order when they are shipped, not
    // when they are manufacturered
    groceryStoreProduct: boolean;
}

export const DEFAULT_PLASTICS_PRODUCT_VERSION: ProductVersion = {
    id: '',

    productId: '',
    fixtureId: '',
    robotProgramId: '',
    plasticsProductCostModelId: '',
    status: ProductVersionStatus.Draft,
    versionNumber: null,

    partNumber: '',
    type: ProductType.FINISHED,
    imageUrl: '',
    thumbnailImageUrl: '',
    stlUrl: '',
    description: '',
    customerPartNumber: '',
    customerId: '',
    drawingResourceId: '',

    createdById: '',
    createdOn: null as unknown as Date,
    updatedById: '',
    updatedOn: null as unknown as Date,
    releasedById: null,
    releasedOn: null,
    releaseComment: '',

    defaultFinishingStationId: '',
    finishingProcedureId: '',

    requiresAsMoldedLabel: false,
    moldFamilyId: '',

    groceryStoreProduct: false,
}
